export class TblUserBidReceipt {
  id?: number;
  employeeId: string;
  bidReceipt: string;

  constructor(employeeId: string, bidReceipt: string) {
    this.employeeId = employeeId;
    this.bidReceipt = bidReceipt;
  }
}
